module.exports = __webpack_public_path__ + "static/media/logo.a46d74bc.svg";